import type { RecipientGroupType } from '@api';
import type { TFunction } from 'i18next';
import type { RecipientGroupOptionType } from '../../types';

// Groups with only CC/BCC recipients have nobody in "To", so they are flagged.
export const getRecipientGroupOptions = (
  groups: RecipientGroupType[],
  t: TFunction<'common'>
): RecipientGroupOptionType[] =>
  groups.map(({ id, label, onlyCcRecipientSet }) => ({
    value: id,
    label: onlyCcRecipientSet
      ? `${label} ${t('REPORTS.MAILING_FORM.CC_ONLY_SUFFIX')}`
      : label,
  }));
